// extracted by mini-css-extract-plugin
export var boldText = "_63-4";
export var checkboxContainer = "_63-6";
export var closeIcon = "_63-i";
export var container = "_63-0";
export var drawer = "_63-8";
export var drawerContent = "_63-9";
export var extraSmallText = "_63-5";
export var fulfillmentGroupTable = "_63-e";
export var largeText = "_63-3";
export var loadingSpinnerContainer = "_63-j";
export var mediumText = "_63-2";
export var narrow = "_63-f";
export var notificationLink = "_63-l";
export var packageCheckIconContainer = "_63-7";
export var slideoutHeaderActions = "_63-g";
export var slideoutHeaderActionsShifted = "_63-h";
export var slideoutHeaderContainer = "_63-a";
export var slideoutModal = "_63-c";
export var stickyHeaderWrapper = "_63-b";
export var table = "_63-k";
export var tableContainer = "_63-d";
export var tertiaryText = "_63-1";